export interface AppConfig {
  appName: string;
}

export function useAppConfig(): AppConfig {
  return {
    appName: (import.meta.env['VITE_APP_NAME'] as string | undefined) ?? 'Contrack',
  };
}
